// Mock data for UNSA AEGIDE DOMITYS website

export const siteInfo = {
  name: "UNSA AEGIDE DOMITYS",
  tagline: "Ensemble, défendons vos droits",
  description: "Section syndicale UNSA au service des salariés d'Aegide Domitys. Nous œuvrons chaque jour pour défendre vos intérêts, améliorer vos conditions de travail et garantir le respect de vos droits.",
  logo: "https://customer-assets.emergentagent.com/job_ba4a44f8-937d-4c19-ad4f-1f2dea199617/artifacts/vfrwjomf_LOGO_UNSA_AEGIDE_DOMITYS_07-24.png",
};

export const aboutText = `L'UNSA AEGIDE DOMITYS est une section syndicale engagée et proche de ses adhérents. Depuis notre création, nous nous battons pour améliorer les conditions de travail de chaque salarié au sein du groupe Aegide Domitys.

Notre mission est claire : représenter, défendre et accompagner les salariés dans leur quotidien professionnel. Que ce soit lors des négociations collectives, des instances représentatives du personnel ou simplement pour répondre à vos questions, nous sommes à vos côtés.

Nous croyons en un dialogue social constructif, basé sur le respect mutuel et la transparence. Notre force réside dans notre proximité avec le terrain et notre connaissance approfondie des enjeux spécifiques à notre secteur d'activité.`;

export const delegates = [
  {
    id: "1",
    name: "Jean Dupont",
    role: "Délégué Syndical",
    email: "jean.dupont@unsa-aegide-domitys.fr",
    photo: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face",
    bio: "Engagé depuis 10 ans au service des salariés d'Aegide Domitys."
  },
  {
    id: "2",
    name: "Marie Martin",
    role: "Déléguée Syndicale",
    email: "marie.martin@unsa-aegide-domitys.fr",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face",
    bio: "Spécialiste du droit du travail, elle accompagne les salariés au quotidien."
  }
];

export const actions = [
  {
    id: "1",
    title: "Négociation Annuelle Obligatoire 2025",
    excerpt: "Retour sur les négociations salariales menées cette année. Des avancées significatives ont été obtenues pour l'ensemble des salariés.",
    content: "Les négociations annuelles obligatoires se sont tenues du 15 janvier au 28 février 2025. L'UNSA AEGIDE DOMITYS a obtenu des avancées significatives pour l'ensemble des collaborateurs.\n\nParmi les points clés négociés :\n- Augmentation générale de 2,5% pour tous les salariés\n- Revalorisation de la prime d'ancienneté\n- Mise en place de 2 jours de télétravail supplémentaires\n- Amélioration de la mutuelle d'entreprise\n\nCes résultats sont le fruit d'un travail de préparation rigoureux et d'une mobilisation exemplaire de nos adhérents.",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=400&fit=crop",
    date: "2025-03-15",
    author: "Jean Dupont"
  },
  {
    id: "2",
    title: "Amélioration des conditions de travail",
    excerpt: "Notre combat pour de meilleures conditions de travail continue. Découvrez les actions menées au premier semestre.",
    content: "L'amélioration des conditions de travail est au cœur de nos préoccupations. Au cours du premier semestre 2025, nous avons mené plusieurs actions concrètes.\n\nNos réalisations :\n- Audit ergonomique des postes de travail\n- Négociation d'un accord sur le droit à la déconnexion\n- Formation sur les risques psychosociaux\n- Mise en place d'un espace de repos rénové",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=400&fit=crop",
    date: "2025-06-20",
    author: "Marie Martin"
  },
  {
    id: "3",
    title: "Formation des élus du personnel",
    excerpt: "Nos élus se forment en continu pour mieux vous représenter et défendre vos droits.",
    content: "La formation continue de nos élus est essentielle pour assurer une représentation de qualité. En 2025, nos délégués ont suivi plusieurs formations spécialisées.\n\nFormations suivies :\n- Droit social et conventions collectives\n- Santé et sécurité au travail\n- Techniques de négociation\n- Gestion des conflits",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=400&fit=crop",
    date: "2025-04-10",
    author: "Jean Dupont"
  }
];

export const news = [
  {
    id: "1",
    title: "Assemblée Générale 2025",
    excerpt: "Notre assemblée générale annuelle se tiendra le 15 septembre. Tous les adhérents sont invités à participer.",
    content: "L'assemblée générale annuelle de l'UNSA AEGIDE DOMITYS se tiendra le 15 septembre 2025.\n\nOrdre du jour :\n- Bilan moral et financier de l'année écoulée\n- Présentation des actions menées\n- Élection du bureau\n- Questions diverses\n\nTous les adhérents sont cordialement invités à participer. Votre présence est importante pour la vie de notre section syndicale.",
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800&h=400&fit=crop",
    date: "2025-08-01",
    author: "UNSA AEGIDE DOMITYS"
  },
  {
    id: "2",
    title: "Nouvelle convention collective",
    excerpt: "Les discussions sur la nouvelle convention collective de branche avancent. Voici les dernières informations.",
    content: "Les négociations pour la nouvelle convention collective de branche sont en cours. L'UNSA est activement impliquée dans ces discussions qui concernent l'ensemble des salariés du secteur.\n\nPoints clés en discussion :\n- Grille salariale révisée\n- Nouvelles classifications des emplois\n- Amélioration des garanties sociales\n- Renforcement de la formation professionnelle",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=400&fit=crop",
    date: "2025-07-18",
    author: "Marie Martin"
  },
  {
    id: "3",
    title: "Journée de solidarité syndicale",
    excerpt: "Retour en images sur notre journée de solidarité organisée le mois dernier.",
    content: "La journée de solidarité syndicale organisée le 20 juin dernier a été un véritable succès. Plus de 50 salariés ont participé à cet événement convivial.\n\nAu programme :\n- Stands d'information sur vos droits\n- Ateliers pratiques\n- Échanges avec les délégués\n- Moment de convivialité",
    image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&h=400&fit=crop",
    date: "2025-07-05",
    author: "UNSA AEGIDE DOMITYS"
  }
];

export const joinInfo = {
  text: `Rejoindre l'UNSA AEGIDE DOMITYS, c'est faire le choix d'un syndicat indépendant, pragmatique et à l'écoute de ses adhérents.

En adhérant, vous bénéficiez :
• D'une protection juridique en cas de litige avec votre employeur
• D'un accompagnement personnalisé dans vos démarches
• D'informations régulières sur vos droits et l'actualité sociale
• D'une voix forte pour défendre vos intérêts
• D'un réseau de solidarité entre salariés

Votre cotisation syndicale est déductible à 66% de vos impôts. Elle représente environ 1% de votre salaire net mensuel.

Pour adhérer, téléchargez le bulletin d'adhésion ci-dessous, remplissez-le et remettez-le à l'un de nos délégués syndicaux.`,
  downloadLabel: "Télécharger le bulletin d'adhésion",
  downloadUrl: "#",
  contactEmail: "contact@unsa-aegide-domitys.fr"
};
